import * as api from 'dashboard/resources/net-sales.api.js';
import actionTypes from './action-types';

export const fetchNetSalesDetailsRequest = () => ({
  type: actionTypes.FETCH_NET_SALES_DETAILS_REQUEST,
  isLoading: true,
});

export const fetchNetSalesDetailsSuccess = (netSalesDetails) => ({
  type: actionTypes.FETCH_NET_SALES_DETAILS_SUCCESS,
  netSalesDetails,
  isLoading: false,
});

export const fetchNetSalesDetailsFailure = () => ({
  type: actionTypes.FETCH_NET_SALES_DETAILS_FAILURE,
  isLoading: false,
});

export const fetchNetSalesDetails = (id = null) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    dispatch(fetchNetSalesDetailsRequest());

    const netSalesDetails = await api.fetchNetSalesDetails({ retailerId });
    dispatch(fetchNetSalesDetailsSuccess(netSalesDetails));
  } catch (error) {
    console.error('NET_SALES_DETAILS', error);
    dispatch(fetchNetSalesDetailsFailure());
  }
};

export const downloadNetSalesReportRequest = () => ({
  type: actionTypes.DOWNLOAD_NET_SALES_REPORT_REQUEST,
});

export const downloadNetSalesReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_NET_SALES_REPORT_SUCCESS,
});

export const downloadNetSalesReportFailure = () => ({
  type: actionTypes.DOWNLOAD_NET_SALES_REPORT_FAILURE,
});

export const downloadNetSalesHistoryReport = ({ id = null, extension, periodType }) => (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = id || session.retailer.retailerId;

    dispatch(downloadNetSalesReportRequest());

    dispatch(downloadNetSalesReportSuccess());
    return api.downloadNetSalesHistoryReport({ retailerId, extension, periodType });
  } catch (error) {
    console.error('DOWNLOAD_NET_SALES_REPORT', error);
    dispatch(downloadNetSalesReportFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/net-sales/net-sales-details.actions.js